import {calculateLeads, getLeadName, getNumberOfLeads} from "../ecg/EcgHelper";
import {EcgData} from "../models/EcgData";

const NULL_ECG_VALUE = -9999.99;

function formatCsvValue(value: number | null | undefined): string {
    if (value === null || value === undefined || Number.isNaN(value)) {
        return String(NULL_ECG_VALUE);
    }
    return String(value);
}

function adcToMilliVolts(value: number, adcScale: number): number {
    return value / adcScale;
}

export function convertEcgDataToCsv(data: EcgData): string {
    const header = data.header;
    const adcChannels = header?.adcChannels ?? 0;
    const sampleRate = header?.sampleRate ?? 0;
    const adcScale = header?.adcScale ?? 0;
    const channels = data.ecg ?? [];
    const isEasi = (header?.sensorConfig ?? 0) === 1;
    const numberOfLeads = getNumberOfLeads(isEasi, adcChannels);
    const sampleCount = channels.reduce((min, channel) => Math.min(min, channel?.length ?? Number.MAX_VALUE), Number.MAX_VALUE);
    const lines: string[] = [];

    if (numberOfLeads === null || sampleCount === Number.MAX_VALUE || sampleCount <= 0 || sampleRate <= 0) {
        return "";
    }

    const columnHeaders = ["time_ms"];
    for (let lead = 0; lead < numberOfLeads; lead++) {
        columnHeaders.push(getLeadName(lead));
    }
    lines.push(columnHeaders.join(","));

    for (let n = 0; n < sampleCount; n++) {
        const channelData: Array<number | null> = [];
        for (let ch = 0; ch < adcChannels; ch++) {
            channelData.push(channels[ch]?.[n] ?? null);
        }

        const leadValues = calculateLeads(isEasi, adcChannels, channelData);
        const timeMs = (n * 1000) / sampleRate;
        const row: string[] = [formatCsvValue(timeMs)];

        for (let lead = 0; lead < numberOfLeads; lead++) {
            const adcValue = leadValues[lead] ?? null;
            if (adcValue === null || adcScale === 0) {
                row.push(formatCsvValue(null));
            } else {
                row.push(formatCsvValue(adcToMilliVolts(adcValue, adcScale)));
            }
        }

        lines.push(row.join(","));
    }

    return lines.join("\n");
}

export function downloadEcgCsv(data: EcgData, fileName: string): void {
    const csv = convertEcgDataToCsv(data);
    const blob = new Blob([csv], {type: "text/csv;charset=utf-8;"});
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}
